import SideDropDownOptions from "./SideDropDownOptions";
import { useContext } from "react";
import { ThemeContext } from "../assets/theme/ThemeContext";

const Header = () => {
  const { themeData } = useContext(ThemeContext);

  return (
    <div
      className="header-container"
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: themeData?.topbar_color,
      }}
    >
      <img src={themeData?.logo} className="logo-bar" alt="Company Logo" />
      <div className="timesheet">
        <div className="options header-dropdown">
          <SideDropDownOptions />
        </div>
      </div>
    </div>
  );
};

export default Header;
